import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import 'iconify-icon';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  const menuItems = [
    { icon: 'solar:home-2-linear', label: 'Dashboard', path: '/admin/dashboard' },
    { icon: 'solar:map-point-linear', label: 'Franquias', path: '/admin/franchises' },
    { icon: 'solar:calendar-linear', label: 'Agenda', path: '/admin/events' },
    { icon: 'solar:users-group-rounded-linear', label: 'Equipe', path: '/admin/team' },
    { icon: 'solar:document-text-linear', label: 'Blog', path: '/admin/blog' },
    { icon: 'solar:chat-square-like-linear', label: 'Depoimentos', path: '/admin/testimonials' },
    { icon: 'solar:question-square-linear', label: 'FAQ', path: '/admin/faq' },
    { icon: 'solar:videocamera-linear', label: 'Eneaflix', path: '/admin/eneaflix' },
    { icon: 'solar:inbox-in-linear', label: 'Submissões', path: '/admin/submissions' },
    { icon: 'solar:gallery-linear', label: 'Mídia', path: '/admin/media' },
    { icon: 'solar:server-square-linear', label: 'Sistema', path: '/admin/system' },
  ];

  return (
    <div className="min-h-screen bg-neutral-50 admin-scope">
      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 z-40 h-screen bg-white border-r border-neutral-200 transition-transform flex flex-col ${
          sidebarOpen ? 'w-64' : 'w-20'
        }`}
      >
        {/* Logo */}
        <div className="h-16 flex items-center justify-between px-4 border-b border-neutral-200">
          {sidebarOpen && (
            <img
              src="https://customer-assets.emergentagent.com/job_b2005392-6212-4506-b62b-d5c77af4b77a/artifacts/n8p0qeqa_Logomarca_Horizontal_Preta.png"
              alt="IE Eneagrama"
              className="h-8"
            />
          )}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-2 hover:bg-neutral-100 rounded-lg transition-colors"
          >
            <iconify-icon
              icon={sidebarOpen ? 'solar:sidebar-minimalistic-linear' : 'solar:hamburger-menu-linear'}
              className="text-2xl"
            ></iconify-icon>
          </button>
        </div>

        {/* Navigation — scrollable so all items reach even on short screens */}
        <nav className="flex-1 overflow-y-auto p-4 space-y-2 pb-4">
          {menuItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                  isActive
                    ? 'bg-black text-white'
                    : 'text-neutral-700 hover:bg-neutral-100'
                }`
              }
            >
              <iconify-icon icon={item.icon} className="text-2xl flex-shrink-0"></iconify-icon>
              {sidebarOpen && <span className="font-medium">{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        {/* User Menu — flex-shrink-0 so it stays put; solid bg + top border
            separate it visually from the last nav item */}
        <div className="flex-shrink-0 p-4 border-t border-neutral-200 bg-white">
          <div className="flex items-center gap-3">
            {user?.picture && (
              <img src={user.picture} alt={user.name} className="w-10 h-10 rounded-full" />
            )}
            {sidebarOpen && (
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm truncate">{user?.name}</p>
                <p className="text-xs text-zinc-700 truncate">{user?.email}</p>
              </div>
            )}
            <button
              onClick={logout}
              className="p-2 hover:bg-neutral-100 rounded-lg transition-colors"
              title="Sair"
            >
              <iconify-icon icon="solar:logout-2-linear" className="text-xl"></iconify-icon>
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <div className={`transition-all ${sidebarOpen ? 'ml-64' : 'ml-20'}`}>
        {/* Top Bar */}
        <header className="h-16 bg-white border-b border-neutral-200 flex items-center justify-between px-6">
          <h1 className="text-xl font-bold">Área Administrativa</h1>
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="px-4 py-2 text-sm font-medium text-neutral-600 hover:text-black transition-colors flex items-center gap-2"
            >
              <iconify-icon icon="solar:eye-linear"></iconify-icon>
              <span>Ver Site</span>
            </button>
          </div>
        </header>

        {/* Page Content */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
